module.exports = __webpack_public_path__ + "static/media/slide-xs-1.4aaa23e3.png";